@if (size$ | async; as size) {
	<article class="dashboard">
		<stages-page-header [headline]="{ translate: 'dashboard.title' }" [backButtonDisabled]="true"></stages-page-header>
		<div class="container column col-12">
			<stages-entry-pages></stages-entry-pages>
		</div>
		<div class="container" [ngClass]="isMediumScreen(size) || isLargeScreen(size) ? 'row' : 'column'">
			<div class="container column" [ngClass]="{ 'col-8': isMediumScreen(size), 'col-4': isLargeScreen(size) }">
				<!--<stages-links></stages-links>-->
				<stages-my-most-frequently-used-elements></stages-my-most-frequently-used-elements>
			</div>
			<div
				class="container"
				[ngClass]="{
					row: isLargeScreen(size),
					column: isMediumScreen(size) || isSmallScreen(size),
					'col-8': isLargeScreen(size) || isMediumScreen(size),
				}"
			>
				<div class="container column" [ngClass]="isSmallScreen(size) ? 'col-12' : 'col-6'">
					<stages-to-do-list></stages-to-do-list>
					<stages-recently-used-files layout="list"></stages-recently-used-files>
				</div>
				<div class="container column" [ngClass]="isSmallScreen(size) ? 'col-12' : 'col-6'">
					<stages-support></stages-support>
					<!-- <stages-my-roles > </stages-my-roles> -->
				</div>
			</div>
		</div>
		<!--
    <stages-media-switch>
      large
      <div *stagesMediaCase="Size.XLARGE" class="container row">
        <div class="container column col-4">
          <stages-my-most-frequently-used-elements></stages-my-most-frequently-used-elements>
        </div>
        <div class="container row col-8">
          <div class="container column col-6">
            <stages-to-do-list></stages-to-do-list>
            <stages-recently-used-files layout="list"></stages-recently-used-files>
          </div>
          <div class="container column col-6">
            <stages-support></stages-support>
          </div>
        </div>
      </div>
      medium
      <div *stagesMediaCase="Size.XSMALL" class="container row">
        <div class="container column col-8">
          <stages-my-most-frequently-used-elements></stages-my-most-frequently-used-elements>
        </div>
        <div class="container column col-8">
          <div class="container column col-6">
            <stages-to-do-list></stages-to-do-list>
            <stages-recently-used-files layout="list"></stages-recently-used-files>
          </div>
          <div class="container column col-6">
            <stages-support></stages-support>
          </div>
        </div>
      </div>
      small
      <div *stagesMediaDefault>
        <div class="container column">
          <stages-my-most-frequently-used-elements></stages-my-most-frequently-used-elements>
        </div>
        <div class="container column">
          <div class="container column col-12">
            <stages-to-do-list></stages-to-do-list>
            <stages-recently-used-files layout="list"></stages-recently-used-files>
          </div>
          <div class="container column col-12">
            <stages-support></stages-support>
          </div>
        </div>
      </div>
    </stages-media-switch>
    -->
	</article>
}
